/** i18n del spinner local mientras el preview no tiene frame (NIF-375). */
export const CAMERA_PREVIEW_STARTING_KEY = 'GENERAL.LOADING.CAMERA_STARTING';

export interface CameraPreviewSwitchHost {
	activatePreviewLoading(textKey: string): void;
	hidePreviewLoading(): void;
}

/** Padre: mostrar spinner al rotar cámara (`app-video` emite `cameraSwitchStarted`). */
export function onCameraPreviewSwitchStarted(host: CameraPreviewSwitchHost): void {
	host.activatePreviewLoading(CAMERA_PREVIEW_STARTING_KEY);
}

/** Padre: ocultar spinner tras `cameraSwitchCompleted` (preview ya listo en VideoComponent). */
export function onCameraPreviewSwitchCompleted(host: CameraPreviewSwitchHost): void {
	host.hidePreviewLoading();
}
